var React = require('react');

function Collapse (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon_-_Collapse_Use_this_one","data-name":"Icon - Collapse Use this one","transform":"translate(1 1)"},React.createElement("line",{"id":"Line_235","data-name":"Line 235","x2":"10","fill":"none","stroke":"#3d5265","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"})));
}

Collapse.defaultProps = {"width":"12","height":"2","viewBox":"0 0 12 2"};

module.exports = Collapse;

Collapse.default = Collapse;
